import { _mapping } from '../i247.Mapping.js';
import { AddressModel, _data } from './data.tyre.js';
import { _utilities } from '../utilities.js';
import '../extensions.js';

class jobLocation {
    static bindControls() {
        if (_utilities.IsMfs()) {
            this.showLocationLabel(true);
        }

        $('.nextButtonSlide').show();

        $('#showDepotGrid').on('click', (e) => {
            $('#depotMapContainer').hide();
            $('#depotGridContainer').show();
            $('#showDepotGrid').ActivateTabButton();

            if (!_data.selectedDepot) return;
            let selectedDepotRadio = $(document).find('.k-grid:visible').find(`input:radio[id="${_data.selectedDepot.id}"]`);
            _data.selectedDepot && selectedDepotRadio.click();
        });

        $('#showDepotMap').on('click', () => {
            $('#depotGridContainer').hide();
            $('#depotMapContainer').show();
            $('#showDepotMap').ActivateTabButton();
        });

        $('input[name="ServiceRequired"]').on('change', () => {
            this.showLocationLabel();
        });
    };

    static showLocationLabel(isMobile = false) {
        var selectedOptionId = $("input[name='ServiceRequired']:checked").val();

        $('#mobileLocationLabel').hide();
        $('#depotLocationLabel').hide();

        if (selectedOptionId === 'D') {
            $('#depotLocationLabel').show();
        } else if (selectedOptionId === 'M' || isMobile) {
            $('#mobileLocationLabel').show();
        }

        $('#CalendarContainer').show();
    }

    static getAddressSlideValidator() {
        return $('#jobAddressSlide').kendoValidator().data('kendoValidator');
    };

    static getValidator() {
        return $('#jobLocationSection').kendoValidator().data('kendoValidator');
    }

    static getDepotValidator() {       
        let validator = $('#grid').kendoValidator({
            rules: {
                depotMissing: function (input) {
                    if (input.is("[type=radio]") && input.attr("required")) {
                        return $("#grid").find("[name=depot-list]").is(":checked");
                    }
                    return true;
                }
            },
            messages: {
                depotMissing: 'Please select a depot'
            }
        }).data('kendoValidator');
        return validator;
    };

    static initialiseDepotList(moveNext) { 
        var selectedDepotId = $("input[name='depot-list']:checked").val();
        const mobileServiceRequired = $("input[name='ServiceRequired']:checked").val() === 'M';

        if (mobileServiceRequired || _utilities.DoNotAllowDepotSelection()) {
            return moveNext();
        } else {
            if (!selectedDepotId) {
                $('.nextButtonSlide').hide();
            }
            _mapping.SetServiceType('T');
            _mapping.SetCustomerId($("#CustomerCompanyId").val());
            _mapping.GetPostcodeCoordinates();
        }
    };

    static saveJobLocation() {
        var locationType = 0;

        //This order is expected in Controller and Service-Api
        if ($("#LocationTypeWork").is(":checked")) {
            locationType = 1
        } else if ($("#LocationTypeHome").is(":checked")) {
            locationType = 2
        }

        let $jobLocationPanel = $('#jobLocationSection');
        _data.bookingDetails.location = new AddressModel(
            $jobLocationPanel.find('input[name="LocationType"]:checked').val(),
            $jobLocationPanel.find('input[id$="Address_AddressLine1"]').val(),
            $jobLocationPanel.find('input[id$="Address_AddressLine2"]').val(),
            $jobLocationPanel.find('input[id$="Address_Town"]').val(),
            $jobLocationPanel.find('input[id$="Address_County"]').val(),
            $jobLocationPanel.find('input[id$="Postcode"]').val()
        );

        _data.bookingDetails.addressType = locationType;

        let depotId = _mapping.GetSelectedDepotId();
        let depots = _mapping.GetDepots();
        _data.bookingDetails.depot = $.grep(depots, function (e) {
            return e.id === depotId;
        })[0];

        _data.bookingDetails.serviceRequired = $jobLocationPanel.find('input[name="ServiceRequired"]:checked').val();

        //try to set the job type
        if (_utilities.IsChecked('ServiceRequiredSameDayMobile')) {
            _data.bookingDetails.jobType = 16;
            _data.bookingDetails.jobTypeName = 'Same Day Mobile';
        } else if (_utilities.IsChecked('ServiceRequiredRapidResponse')) {
            _data.bookingDetails.jobType = 12;
            _data.bookingDetails.jobTypeName = 'Rapid Response';
        } else if (_utilities.IsChecked('ServiceRequiredNextDayMobile')) {
            _data.bookingDetails.jobType = 61;
            _data.bookingDetails.jobTypeName = 'Next Day Mobile';
        }
    };
}

export { jobLocation as _jobLocation }
